import React from 'react'

import { connect } from 'react-redux'
import { Item, Box } from 'react-html-email';

import Row from "./row"

class Body extends React.Component {
    render() {
        const bodyContent =  this.props.body.map((content, index) => (
            <Item key={index} align={content.align}>
                <Row content={content} html={this.props.html} section="body" index={index}/>
            </Item>
        ));

      return (
        <Box width="100%" >
            {bodyContent}
        </Box>
      );
    }
  }

const mapStateToProps = (state) => {
    return {
        body: state.design.body,
        folder: state.design.folder
    };
}

export default connect(
    mapStateToProps
  )(Body)